<template>
    <div class="w-1200" v-loading="loading">
        <div class="onLineAnswerBox">
            <div class="padding-y">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item>首页</el-breadcrumb-item>
                    <el-breadcrumb-item>试题精炼</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <!--左侧诊断助手-->
            <div class="diagnosticAid commonShadow delFloat padding-b">
                <div class="text-default-color cursorSz zdrow" @click="lookErrorQuestion">
                    <span>
                        我的错题
                    </span>
                    <span class="text-ellipsis" :title="wrongCount"> ({{wrongCount}})</span>
                </div>
                <div class="text-default-color cursorSz margin-right zdrow" @click="openFav">
                    <span>
                        我的收藏
                    </span>
                    <span class="text-ellipsis" :title="collectionCount"> ({{collectionCount}})</span>
                </div>
                <div class="text-default-color cursorSz   margin-right zdrow" @click="searchTestNote">
                    <span  >
                        练习记录
                    </span>
                    <span class="text-ellipsis" :title="answerCount"> ({{answerCount}})</span>
                </div>
                <el-divider></el-divider>
                <div>
                    <div class="margin-bottom">
                        <span>学科：</span>
                        <span class="sonBox padding-x w-100 cursorSz" @click="selectSubject(item.subjectId)" v-for="item in subjectList" :key="item.subjectId" :class="subjectId===item.subjectId?'directoryActive':''">
                            <span>
                                <span></span>
                                <span>{{item.subjectName}}</span>
                            </span>
                        </span>
                    </div>
                    <div class="lists" v-show="bookList.length>0&&!loadingBook">
                        <span>课程：</span>
                        <span v-for="(itemF,index) in bookList" @click="searchCurriculum(itemF.type)"
                              :class="bookId===itemF.type ?'directoryActive':''"
                              :key="index" class="margin-top margin-right cursorSz"  v-show="itemF.children.length>0" >
                            {{itemF.typeName}}
                        </span>
                    </div>
                    <div class="position-relative">
                        <div class="delFloat  typeLists" :class="zd?'show':''" v-show="bookList.length>0&&!loadingBook">
                            <div class="float-left margin-top">类型：</div>
                            <div class="float-left delFloat listsSon">
                                <div v-for="itemS in curriculumSonList"
                                     @click="selectLeftKnowledge(itemS.knowledgeId)"
                                     :class="itemS.knowledgeId===knowLedgeId?'directoryActive':''"
                                     :key="itemS.knowledgeId" class="margin-top margin-right float-left cursorSz"   >
                                    {{itemS.knowledgeTitle}}
                                </div>
                            </div>
                        </div>
                        <div class="diszd position-absolute cursorSz">
                            <span @click="zd=true" v-show="zd===false">更多 <span class="el-icon-arrow-down"></span></span>
                            <span @click="zd=false" v-show="zd===true">折叠 <span class="el-icon-arrow-up"></span></span>
                        </div>
                    </div>

                    <div></div>
                    <div></div>
                </div>
            </div>
            <div class="modelItem margin-top delFloat commonBackground  ">
                <div  class="float-left modelBox leftInside third position-relative">
                    <div class="text-l-size font-weight-bold">
                        知识点目录
                    </div>
                    <div class="modelInside margin-top lists public_scroll_bar" v-show="chapterList.length>0&&!loadingChapter">
                        <el-tree @current-change="changeNode"
                                 :data="chapterList"
                                 default-expand-all
                                 node-key="id"
                                 ref="tree"
                                 accordion
                                 :highlight-current=true
                                 :props="defaultProps">
                            <!--嵌套其中的值，scope的data可以获得当前节点的值，这样写实现嵌套效果-->
                            <div slot-scope="{node,data}" style=" height: 30px">
                                <div class="float-left">
                                    <el-tooltip placement="right-start" v-if="data.title.length>10" :content="data.title">
                                        <div class="text-ellipsis" :class="getChapterId===data.id?'directoryActive':''" >
                                            <span :class="node.level===1?'font-weight-bolder':''">
                                                {{data.title}}
                                            </span>
                                        </div>
                                    </el-tooltip>
                                    <div v-else  :class="getChapterId===data.id?'directoryActive':''">
                                        <span :class="node.level===1?'font-weight-bolder':''">
                                            {{data.title}}
                                        </span>
                                    </div>
                                </div>

                            </div>
                        </el-tree>
                    </div>
                    <empty v-show="!loadingChapter&&knowLedgeId!==''&&chapterList.length<1" content="暂无知识点内容" :text-size="16" :heights="120" :widths="120"></empty>
                    <loading :show="loadingChapter" width="470px"></loading>
                </div>
                <div  class="float-left modelBox third position-relative modelFour border-0">
                    <div class="modelInside lists public_scroll_bar" v-show="chapterList.length>0&&!loadingChapter">

                        <div>
                            <div class="endTestLine delFloat padding-y" v-for="item in endBeginTestList" :key="item.id">
                                <div class="float-left">
                                    <el-tooltip placement="right-start" v-if="item.title.length>10" :content="item.title">
                                        <div class="text-ellipsis  testText" :class="getChapterId===item.id?'directoryActive':''" >
                                                {{item.title}}
                                        </div>
                                    </el-tooltip>
                                    <div v-else class="text-s-secondary testText" :class="getChapterId===item.id?'directoryActive':''">
                                            {{item.title}}
                                    </div>
                                </div>
                                <div class="float-right" v-show="item.isLast">
                                    <el-popover
                                            placement="left-end"
                                            width="200"
                                            trigger="click">
                                        <div class="text-center margin-top">选择题目难度</div>
                                        <div>
                                            <div v-for="items in difficultList" class="margin-top" :key="items.id">
                                                <el-button @click="startTest(items.id,item.id)" style="width: 100%;" >{{items.name}}</el-button>
                                            </div>
                                        </div>
                                        <span slot="reference" style="color:#4A8FFF;" class="cursorSz testBth">
                                            开始练习 <span> > </span>
                                        </span>
                                    </el-popover>
                                </div>
                            </div>
                        </div>
                    </div>
                    <empty v-show="!loadingChapter&&knowLedgeId!==''&&chapterList.length<1" content="暂无知识点内容" :text-size="16" :heights="120" :widths="120"></empty>
                    <loading :show="loadingChapter" width="470px"></loading>
                </div>
            </div>
        </div>
        <common-target-router @clearHref="clearHref" :get-location="getLocation"></common-target-router>
    </div>
</template>

<script>
    import {
        questionBankGetKnowledge,
        tesetQuestionBankLogCount,
        testQuestionBankBook,
        testQuestionBankChapters,
        testQuestionBankCreatePaper,
        testQuestionBankSubject
    } from "../../config";
    export default {
        name: "onLineAnswer",
        data(){
            return{
                //课程类型（课程同步，高考复习）
                curriculumId:'',
                loading:false,
                curriculumSonList:[],
                curriculumTypeId:'',
                defaultProps: {children: 'children',label: 'title'},
                //已选的学科
                subjectId:'',
                loadingSubject:false,
                subjectList:[],
                //易中难
                difficultList:[
                    {id:1,name:'易'},
                    {id:2,name:'中'},
                    {id:3,name:'难'}
                ],
                stepList:[
                    {
                        id:1,
                        name:'选择科目'
                    },
                    {
                        id:2,
                        name:'选择教材'
                    },
                    {
                        id:3,
                        name:'选择知识点，开始练习'
                    },
                ],
                //知识点id
                knowLedgeId:'',
                //教材id
                bookId:'',
                //教材列表
                bookList:[],
                //教材加载
                loadingBook:false,
                //获取章节列表
                chapterList:[],
                //章节Id
                getChapterId:'',
                //加载章节
                loadingChapter:false,
                getLocation:'',
                //收藏记录
                collectionCount:0,
                //错题数量
                wrongCount:0,
                //答题记录数量
                answerCount:0,
                nodeLevel:'lll',
                zd:false,
                //末节开始练习content
                endBeginTestList:[]
            }
        },
        mounted(){
            this.showNoteCount();
            this.getSubjectList();
        },
        methods:{
            //查看练习记录页面
            async searchTestNote(){
                let {href} =this.$router.resolve({path:'/questionPracticeNotes'});
                this.getLocation=href;
            },
            //查看错题
            lookErrorQuestion(){
                const {href}=this.$router.resolve({path:'/answerCollectionList',query:{name:'second'}})
                this.getLocation=href;
            },
            //展示三种记录的数量
            async showNoteCount(){
                let result=await tesetQuestionBankLogCount();
                if(result.status){
                    this.collectionCount=result.data.favCount;
                    this.answerCount=result.data.quesCount;
                    this.wrongCount=result.data.wrongNoteCount;
                }
            },
            openFav(){
                const {href}=this.$router.resolve({path:'/answerCollectionList',query:{name:'first'}})
                this.getLocation=href;
            },
            clearHref(){
                this.getLocation='';
            },
            //开始练习
            async startTest(val,chapterId){
                console.log(val);
                console.log(chapterId);
                let result=await testQuestionBankCreatePaper(this.subjectId,chapterId,this.bookId,val);
                if(result.status){
                    console.log(result.data);
                    console.log(result.data.paperId);
                    const {href}=this.$router.resolve({path:'/onLineABegin',query:{paperId:result.data.paperId}});
                    this.getLocation=href;
                }
            },

            //获取当前tree节点所选择的内容
            changeNode(val){
                console.log('我变化了');
                console.log(val);
                this.getChapterId=val.id;
                this.questionBankGetKnowledge();
            },
            //选择左侧知识点
            selectLeftKnowledge(val){
                this.knowLedgeId=val;

                this.searchChapter();
            },
            //根据知识点及教材id查出章节
            async searchChapter(){
                this.loadingChapter=true;
                let result=await testQuestionBankChapters(this.knowLedgeId,this.bookId,this.subjectId);
                if(result.status){

                    this.loadingChapter=false;
                    console.log('获取知识点的内容');
                    console.log(result.data);
                    this.chapterList=result.data.knowledges;
                    if(result.data.knowledges[0].children!==null){
                        this.getChapterId=result.data.knowledges[0].children[0].id;
                    }else{
                        this.getChapterId=result.data.knowledges[0].id;
                    }


                    this.questionBankGetKnowledge();
                    console.log(this.chapterList.length);
                }else{
                    this.loadingChapter=false;
                }
            },
            //根据章节id获取末节
            async questionBankGetKnowledge(){
                let result=await questionBankGetKnowledge(this.getChapterId,this.bookId,this.subjectId);
                if(result.status){
                    this.endBeginTestList=result.data;
                    console.log(result.data);
                    this.loading=false;
                }else{
                    this.loading=false;
                }
            },
            //选择展示或隐藏当前目录
            getDisplay(valId,valSelect){
                this.bookList.map((val)=>{
                    if(valId===val.type){
                        return val.selected=!valSelect;
                    }
                    return val;
                })
                console.log(this.bookList);
            },

            selectSubject(val){
                this.subjectId=val;
                this.searchBook();
            },
            //根据课程查出类型
            searchCurriculum(val){
               if(val){
                   this.bookId=val;
               }
               let zhi = this.bookList.filter((val)=>{
                    return val.type===this.bookId;
                })
                // console.log(this.curriculumSonList);
                this.curriculumSonList=zhi[0].children;
                console.log(zhi );
                console.log(zhi[0].children);
                if(zhi[0].children.length>0){
                    this.knowLedgeId=zhi[0].children[0].knowledgeId
                    this.searchChapter();
                }
                // this.knowLedgeId=this.curriculumSonList[0].knowledges[0].knowledgeId;
            },
            //根据学科id查出教材
            async searchBook(){
                this.loadingBook=true;
                let result=await testQuestionBankBook(this.subjectId);
                if(result.status){
                    this.bookList=[];
                    result.data.forEach((val)=>{
                        this.bookList.push({
                            type:val.type,
                            typeName:val.typeName,
                            selected:true,
                            children:val.knowledges
                        })
                    })
                    console.log('我是教材');
                    console.log(result.data);
                    if(result.data[0].knowledges.length>0){
                        this.bookId=result.data[0].type;
                    }else{
                        this.bookId=result.data[1].type;

                    }
                    this.searchCurriculum();
                    if(result.data[0].knowledges.length<1){
                        this.knowLedgeId=result.data[1].knowledges[0].knowledgeId;
                    }else{
                        this.knowLedgeId=result.data[0].knowledges[0].knowledgeId;
                    }
                    this.loadingBook=false;

                }else{
                    this.loadingBook=false;
                }
            },
            //查出学科列表
            async getSubjectList(){
                this.loading=true;
                this.loadingSubject=true;
                let result=await testQuestionBankSubject();
                if(result.status){
                    this.loadingSubject=false;
                    this.subjectList=result.data;
                    this.subjectId=result.data[0].subjectId;
                    console.log(result.data);
                    this.searchBook();
                }else{
                    this.loadingSubject=false;
                }
            },
            //查出
        }
    }
</script>

<style lang="scss" scoped>
    .onLineAnswerBox{
        min-height: 100%;
        .rightTitle{
            margin-left: 160px;
            color:#666666;
            font-size: 16px;
        }
        .diagnosticAid{
            width: 100%;

            padding: 16px 12px 24px;
            background: url(data:image/png;base64,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) no-repeat;
            background-size: 100% 100%;
            .diagnosticTopic{
                font-size: 16px;
                margin-left: 8px;
                color: #333333;
                line-height: 24px;
            }
            .zdrow{
                float: left;
                width:100px;
                height:1em;
                span{
                    color:#4A8FFF;
                }
            }
        }
        .typeLists{
            width:calc(100% - 20px)!important;
            height:40px;
            overflow: hidden;
            .listsSon{
                width:calc(100% - 90px)!important;
            }
        }
        .diszd{
            right:0;
            top:15px;
            span{
                color:#4A8FFF;
            }
        }
        .typeLists.show{
            height:auto;
            overflow: visible;
        }
        .modelItem{
            /*overflow: auto;*/
            padding-left: 10px;
            height:calc(100vh - 200px);
            .leftInside{
                width:280px;

            }
            .modelBox{
                height: 100%;
                color: #666666;

                border-right:1px solid #e5e5e5;

                .modelInside{
                    height: 100%;
                    .endTestLine{
                        border-bottom: 1px dashed #000000;
                        .testText{
                            color:rgba(0,0,0,.65)
                        }

                    }
                }
                .sonBox{
                    width: 200px;
                    height:40px;
                    line-height: 40px;
                }
                .lists{
                    height:calc(100vh - 220px);
                    overflow: auto;
                }
            }
            .modelFour{
                width:calc(100% - 289px);
            }
            .modelBox.third{
                padding: 15px;


            }
        }
        .rightBox{
            background: #ffffff;
            .stepWrapper{
                width: 100%;
                background:#ffffff;
                padding-left: 24px;
                border-bottom: 1px solid #EEEEEEFF;
                border-top-left-radius: 4px;
                border-top-right-radius: 4px;
                .stepItem{
                    height: 50px;
                    .num{
                        width: 16px;
                        height: 16px;
                        background: #2E86FFFF;
                        border-radius: 8px;
                        color: white;
                        font-size: 14px;
                        text-align: center;
                        line-height: 16px;
                    }
                    .title{
                        font-size: 14px;
                        color: #2E86FFFF;
                        margin-left: 8px;
                        font-weight: 500;
                    }
                    .line{
                        height: 1px;
                        border-bottom: 1px dashed #2e86ff;
                        width: 92px;
                        margin-left: 16px;
                        margin-right: 16px;
                    }
                }
            }

        }
    }
</style>
